export default __webpack_public_path__ + "static/media/tiktok.43887845.svg";